import React from 'react';
import Chip from '@mui/material/Chip';
import type { StaffRole } from '../constants/staff';

const ROLE_CHIP_COLOR: Record<
  StaffRole,
  'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
> = {
  管理者: 'error',
  医師: 'primary',
  看護師: 'success',
  事務員: 'info',
};

type RoleChipProps = {
  role: StaffRole;
  /** @default small */
  size?: 'small' | 'medium';
};

/**
 * 役職を Chip で色分けして表示する
 */
const RoleChip: React.FC<RoleChipProps> = ({ role, size = 'small' }) => (
  <Chip
    label={role}
    color={ROLE_CHIP_COLOR[role]}
    size={size}
    variant="outlined"
    sx={{
      fontWeight: 600,
      borderRadius: size === 'small' ? '6px' : '8px',
      ...(size === 'small' && {
        height: 22,
        fontSize: '0.7rem',
        '& .MuiChip-label': { px: 0.75 },
      }),
    }}
  />
);

export default RoleChip;
